module.exports = __webpack_public_path__ + "static/designer-799d56f9653aeefdf0ac7e858fc87249.jpg";